<div class="bodyCheck">
  <div class="fx-row" id="checkOut">
    <div class="m-t-30 fx-col fx-flex-100">
      <div class="main fx-row fx-flex-in-col">
        <div class="gt-xs-fx-flex-10"></div>
        <div class="xs-fx-flex-100 gt-xs-fx-flex-80">
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="fx-col fx-main-between fx-cross-stretch">
                <div class="fx-row fx-main-center fx-cross-center fx-flex-100-in-col">
                  <span class="header" translate="review_"></span>
                </div>
                <div class="m-t-15 fx-row lt-md-fx-col fx-flex-100-in-col">
                  <div class="p-l-r-15 m-t-10 fx-col lt-md-fx-flex-30-in-col print-fx-flex-30 gt-sm-fx-flex-30">
                    <h5 class="f-bold" translate="shipping_address_lower"></h5>
                    <div>
                      <span [textContent]="userService.shippingAddress.FullName"></span><br>
                      @if (!isStateRestrict && !utilityService.isEmptyObject(userService.shippingAddress)) {
                        <address class="color-f-s-14 m-b-0 viewAddress"
                          >
                          <span [textContent]="userService.shippingAddress.Street1"></span>&nbsp;
                          <span [textContent]="userService.shippingAddress.Street1"></span>&nbsp;
                          <span [textContent]="userService.shippingAddress.City"></span>&nbsp;
                          <br>
                            <span [textContent]="userService.shippingAddress.Region"></span>&nbsp;
                            <span [textContent]="userService.shippingAddress.CountryCode"></span>&nbsp;
                            <span [textContent]="userService.shippingAddress.PostalCode"></span>
                          </address>
                        }
                      </div>
                      <div class="edit_ship_address">
                        @if (utilityService.isEmptyObject(userService.shippingAddress)) {
                          <button mat-raised-button color="primary"
                            class="m-l-0"
                            routerLink="/shipping" [translate]="'add_address'" aria-label="AddAddress">{{'add_address' |
                          translate}}</button>
                        }
                        @if (!utilityService.isEmptyObject(userService.shippingAddress)) {
                          <a class="itemName" href=""
                          routerLink="/shipping" translate="edit_"></a>
                          }<br>
                        </div>
                        <div class="m-t-25">
                          @if (userService.customerData.EmailAddress) {
                            <mat-icon class="p-r-10 color-icon disp" [textContent]="'mail'"
                            >mail</mat-icon>
                          }
                          <span class="mail_position1" [textContent]="userService.customerData.EmailAddress"></span>
                        </div>
                      </div>
                      <div class="p-l-r-15 m-t-10 fx-col lt-md-fx-flex-40-in-col print-fx-flex-40 gt-sm-fx-flex-40">
                        <p class="f-bold" translate="shop_payment_new"></p>
                        <div class="fx-row fx-main-start fx-cross-center">
                          <p class="p-r-5" translate="accepted_cards"></p>
                          <div>
                            <img src="assets/images/visa1.png" alt="VisaCard">
                            <img src="assets/images/mastercard.png" alt="VisaCard">
                          </div>
                        </div>
                        @if (userService.paymentMethods.length >0) {
                          <div>
                            <span [textContent]="userService.paymentMethods[0].CardType"></span>&nbsp;
                            @if (userService.paymentMethods[0].Last4) {
                              <span><span translate="card_ending_in"></span></span>
                            }
                            <span [textContent]="userService.paymentMethods[0].Last4"></span>
                            <br>
                              @if (userService.paymentMethods[0].ExpireMonth!==0 && userService.paymentMethods[0].ExpireYear!==0) {
                                <span
                                  >
                                  <span>{{'expires'|translate}}</span>&nbsp;
                                  <span [textContent]="userService.paymentMethods[0].ExpireMonth"></span> /
                                  <span [textContent]="userService.paymentMethods[0].ExpireYear"></span>
                                </span>
                              }
                            </div>
                          }
                          @if (userService.paymentMethods.length == 0) {
                            <div>
                              <span translate="no_payment"></span>
                            </div>
                          }
                          <div class="fx-row">
                            <mat-form-field class="fx-flex" appearance="outline">
                              @if (userService.paymentMethods.length > 0 && !userService.isPaymentChanged) {
                                <mat-label
                                  [textContent]="userService.paymentMethods[0].CardType + ' ' + userService.paymentMethods[0].Last4">
                                </mat-label>
                              }
                              @if (userService.paymentMethods.length == 0) {
                                <mat-label
                                translate="unified_add_payment_method"></mat-label>
                              }
                              <mat-select>
                                <mat-select-trigger>
                                  @if (userService.paymentMethods.length > 0) {
                                    <span>
                                      {{userService.paymentMethods[0].CardType}} {{ ' ' }}
                                      {{userService.paymentMethods[0].Last4}}
                                    </span>
                                  }
                                </mat-select-trigger>
                                @if (paymentService.PaymentTypeResponse['SaveMethods']) {
                                  @for (paymentMethod of paymentService.PaymentTypeResponse['SaveMethods']; track paymentMethod) {
                                    <mat-option
                                      value="Credit Card" (click)="addSavePayment(paymentMethod);" class="c-color1"
                                      [attr.merchant_id]="paymentMethod.MerchantId" translate>
                                      <mat-icon class="p-r-10">credit_card</mat-icon>
                                      <span style="cursor: pointer">
                                        <span [textContent]="getPaymentDescription(paymentMethod)"></span>
                                        <span>
                                          {{'_exp'|translate}}&nbsp;&nbsp;
                                          <span [textContent]="paymentMethod.Expires | date:'MM/yyyy'"></span>
                                        </span>
                                      </span>
                                      <span class="multipay__dropdown-list__filler"></span>
                                      <button mat-icon-button class="btn-icon btn-icon--small btn-link"
                                        (click)="removeCardDetail(paymentMethod);">
                                        <mat-icon class="p-r-10">delete</mat-icon>
                                      </button>
                                    </mat-option>
                                  }
                                }
                                @if (paymentService.PaymentTypeResponse['AllowedMethods']) {
                                  @for (addpayments of paymentService.PaymentTypeResponse['AllowedMethods']; track addpayments) {
                                    <mat-option
                                      value="Credit Card" (click)="addSavePayment(addpayments);" class="c-color1"
                                      [attr.merchant_id]="addpayments.MerchantId"
                                      [innerHTML]="addpayments.DisplayName | paymentTranslate:addpayments.DisplayName"
                                    translate></mat-option>
                                  }
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                          @if ((paymentService.SelectedPaymentTypes.CanSavePayments == false || paymentService.SelectedPaymentTypes.CanSavePayments == 'false')) {
                            <div class="ds-row__item clearfix m-l-0"
                              >
                              @if (!userService.paymentMethods[0].Redirect) {
                                <span class="ds-row__item clearfix"
                                [innerHTML]="('order_pending') | translate" translate></span>
                              }
                              @if (userService.paymentMethods[0].Redirect) {
                                <span class="ds-row__item clearfix"
                                [innerHTML]="('order_needs_redirect') | translate" translate></span>
                              }
                              <span [innerHTML]="('click_here_payment_inst') | translate">
                              </span>
                            </div>
                          }
                          <div [innerHTML]="('card_type_logos') | translate"></div>
                        </div>
                        <div class="p-l-r-15 m-t-10 fx-col lt-md-fx-flex-30-in-col print-fx-flex-30 gt-sm-fx-flex-30">
                          <p class="f-bold" translate="choosing_a_shipping"></p>
                          <div class="m-t-10">
                            @if (itemsService.selectedOrderItems.length) {
                              <mat-radio-group aria-label="Select an option" class="fx-col"
                                [(ngModel)]="userService.selectedShippingMethod">
                                @for (shipmethod of orderService.calculateOrderResponse.ShippingMethods; track shipmethod) {
                                  <mat-radio-button class="m-b-10 font-IBM" [value]="shipmethod.ShipMethodId"
                                    (click)="updateShipmethod(shipmethod.ShipMethodId)">
                                    <div class="fx-col">
                                      <div>
                                        <span [textContent]="shipmethod.Description"></span>
                                      </div>
                                      <div>
                                        <small class="text-muted"
                                        [textContent]="shipmethod.ShippingAmount | currency: companyService.selectedCurrency.CurrencyCode"></small>
                                      </div>
                                    </div>
                                  </mat-radio-button>
                                }
                              </mat-radio-group>
                            }
                            @if (itemsService.selectedAutoOrderItems.length && !itemsService.selectedOrderItems.length) {
                              <mat-radio-group aria-label="Select an option" class="fx-col"
                                [(ngModel)]="userService.selectedShippingMethod"
                                >
                                @for (shipmethod of orderService.calculateAutoOrderResponse.ShippingMethods; track shipmethod) {
                                  <mat-radio-button class="m-b-10 font-IBM" [value]="shipmethod.ShipMethodId"
                                    (click)="updateShipmethod(shipmethod.ShipMethodId)">
                                    <div class="fx-col">
                                      <div>
                                        <span [textContent]="shipmethod.Description"></span> <span
                                      [textContent]="shipmethod.ShippingAmount"></span>
                                    </div>
                                  </div>
                                </mat-radio-button>
                              }
                            </mat-radio-group>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <br>
                @if (configService.localSettings.Global.OrderAllowCoupons && itemsService.selectedOrderItems.length > 0) {
                  <mat-card appearance="outlined">
                    <mat-card-header>
                      <mat-card-title class="header">
                        <mat-icon class="p-r-10">card_giftcard</mat-icon> <span class="header font-IBM"
                      translate="promo_coupon_code"></span>
                    </mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="fx-col" >
                    @if (promoShowHide()) {
                      <div class="p-l-10 fx-row fx-main-start fx-cross-stretch fx-flex-100-in-col"
                        >
                        <div class="p-l-r-15 m-t-10 fx-row fx-flex-25 xs-fx-flex-70">
                          <mat-form-field class="fx-flex" appearance="outline">
                            <mat-label class="font-IBM" translate="Enter_promo_code"></mat-label>
                            <small class="c-red coupon_error font-IBM"
                            [textContent]="userService.couponInfo.promoCodeValid === false ? ('Invalid_promo_code' | translate) : ''"></small>
                            <input class="font-IBM" name="promoCode" matInput [(ngModel)]="userService.couponInfo.promoCode"
                              (keypress)="userService.couponInfo.promoCodeValid =''">
                          </mat-form-field>
                        </div>
                        <div class="m-t-10 applyButton fx-flex-20 xs-fx-flex-15">
                          <button mat-raised-button color="primary" [disabled]="!userService.couponInfo.promoCode"
                          (click)="validatePromoCode();" class="font-IBM m-t-10" translate="">{{'apply_code' | translate}}</button>
                        </div>
                      </div>
                    }
                    <div class="p-l-10 m-l-10 fx-row fx-main-between fx-cross-stretch fx-flex-100-in-col">
                      @for (Coupon of orderService.calculateOrderResponse.CouponResults; track Coupon) {
                        <div>
                          @if (Coupon.IsValid && userService.couponInfo.OrderAllowCoupons) {
                            @if (isCouponCode(Coupon)) {
                              <mat-chip-listbox aria-label="CouponCode">
                                <mat-chip-option  [removable]="removable"
                                  (removed)="removePromo(Coupon.Code);">
                                  <span [textContent]="Coupon.Code"></span> &nbsp;&nbsp;
                                  <span>-</span>
                                  <span
                                  [textContent]="Coupon.Discount | currency:(orderService.calculateOrderResponse.CurrencySymbol || this.companyService.selectedCurrency.CurrencyCode)"></span>
                                  <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                  </button>
                                </mat-chip-option>
                              </mat-chip-listbox>
                            }
                          }
                        </div>
                      }
                    </div>
                  </mat-card-content>
                </mat-card>
              }
              <br>
                @if (itemsService.selectedOrderItems.length > 0) {
                  <mat-card appearance="outlined">
                    <mat-card-header>
                      <mat-card-title class="header" translate="order_summary"></mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="fx-row">
                      <div class="p-l-r-15 m-t-10 fx-col fx-flex-100">
                        <div class="borderBottom cart-items__header fx-row fx-flex-100-in-col">
                          <div class="fx-flex-50">
                            <span class="color2-f-s-14" translate="items_"></span>
                          </div>
                          <div class="fx-flex-30">
                            <span class="color2-f-s-14" translate="price"></span>
                          </div>
                          <div class="fx-flex-20">
                            <span class="color2-f-s-14" translate="global_quantity"></span>
                          </div>
                        </div>
                        @for (item of itemsService.selectedOrderItems; track item) {
                          <div class="items fx-row fx-flex-100-in-col">
                            <div class="fx-row fx-flex-50">
                              <div class="cart-items__images fx-flex-15">
                                <img [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/images/inventory'+item.ImageUrl"
                                  [default]="'assets/images/noimage.png'">
                                </div>
                                <div class="m-t-30 fx-col fx-flex-85">
                                  <div>
                                    <a class="product_detail_text itemName" [textContent]="item.ProductName"
                                    (click)="cart1Service.showProductDetail(item, false, item.HasOptions, false);"></a>
                                    <!-- Warnings -->
                                    @if (showBirthWarnings()) {
                                      <sup class="c-color1" translate="prop_65">
                                      </sup>
                                    }
                                    @if (showCancerWarnings()) {
                                      <sup class="c-color1"
                                      [innerHTML]="(showCancerWarnings() ? 'prop_65_es' : 'prop_65') | translate"></sup>
                                    }
                                  </div>
                                  <div>
                                    @if (item.selectedOptions) {
                                      <span class="f-s-12" [textContent]="item.selectedOptions"></span>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="fx-row fx-main-start fx-cross-center fx-flex-30 xs-fx-flex-22">
                                <span [textContent]="item.Price | currency: companyService.selectedCurrency.CurrencyCode"></span>
                              </div>
                              <div class="fx-row fx-main-start fx-cross-center fx-flex-20">
                                <div class="fx-row">
                                  <div class="input-group fx-row fx-main-center fx-cross-center">
                                    <span class="input-group-btn">
                                      <button mat-button-icon class="" type="button"
                                        (click)="cart1Service.decreaseQuantiy(item,false,false)">
                                      <mat-icon class="c-gray">remove</mat-icon>
                                    </button>
                                  </span>
                                  <input type="text" class="input-control" maxlength="2"
                                    [(ngModel)]="getQuantityModel('order',item)[item.ItemID]" validate inputonlynumber="true"
                                    (change)="checkQuantity('order', item)"
                                    (keyup)="($event.which === 38) ? cart1Service.increaseQuantiy(item, false, false) : 0"
                                    (keydown)="($event.which === 40) ? cart1Service.decreaseQuantiy(item, false, false) : 0">
                                  <span class="input-group-btn">
                                    <button mat-button-icon class="" type="button"
                                      (click)="cart1Service.increaseQuantiy(item,false,false)">
                                      <mat-icon class="c-gray">add</mat-icon>
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="m-t-10 order-total-summary fx-col fx-flex-100-in-col">
                          <div class="fx-row fx-main-end fx-cross-stretch">
                            <label translate="sub_total"></label><strong class="m-l-10"
                          [textContent]="(orderService.calculateOrderResponse.SubTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
                        </div>
                        <div class="fx-row fx-main-end fx-cross-stretch">
                          <label translate="discounttotal"></label><strong class="m-l-10"
                        [textContent]="(orderService.calculateOrderResponse.DiscountTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
                      </div>
                      <div class="fx-row fx-main-end fx-cross-stretch">
                        <label translate="shippingtotal"></label><strong class="m-l-10"
                      [textContent]="(orderService.calculateOrderResponse.ShippingTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
                    </div>
                    <div class="fx-row fx-main-end fx-cross-stretch">
                      <label translate="taxtotal"></label><strong class="m-l-10"
                    [textContent]="(orderService.calculateOrderResponse.TaxTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
                  </div>
                </div>
                <div class="m-t-10 order-items-total fx-flex-100-in-col">
                  <div class="fx-row fx-main-end fx-cross-stretch">
                    {{'global_total'|translate}} ( <span data-text="quantity"
                  [textContent]="itemsService.selectedOrderItems.length"></span> {{'item_'|translate}} ):
                  <strong class="m-l-10">
                    <span [textContent]="(orderService.calculateOrderResponse.Total | currency: companyService.selectedCurrency.CurrencyCode)"></span>
                  </strong>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
      <br>
        @if (itemsService.selectedAutoOrderItems.length > 0) {
          <mat-card appearance="outlined" class="fx-row">
            <div class="fx-col fx-flex-100">
              <div class="fx-row fx-main-between fx-cross-stretch fx-flex-100-in-col">
                <div class="fx-flex-49">
                  <mat-card-header>
                    <mat-card-title class="header">{{'autoship_order'|translate}}</mat-card-title>
                  </mat-card-header>
                </div>
                <div class="p-l-r-15 fx-row fx-main-end fx-cross-stretch fx-flex-49">
                  <span translate>
                    {{'your_autoship_will_process_frequency' | translate: getfrequencyName()}}
                  </span> &nbsp;
                  <span [textContent]="autoshipConfigurationService.autoshipDate | changedateformat"></span>
                </div>
              </div>
              <div>
                <mat-card-content class="fx-row">
                  <div class="p-l-r-15 m-t-10 fx-col fx-flex-100">
                    @if (userService.customerData && (AutoOrdersData && AutoOrdersData.length > 0) && itemsService.selectedAutoOrderItems.length > 0) {
                      <div class="m-b-15 fx-col"
                        >
                        <div class="fx-row xs-fx-col fx-flex-100-in-col">
                          <div class="fx-row fx-main-start fx-cross-center xs-fx-flex-100-in-col print-fx-flex-80 gt-xs-fx-flex-80">
                            <div class="fx-col fx-flex-100">
                              <div class="m-b-10">
                                <mat-radio-group name="opList" class="fx-col"
                                  [(ngModel)]="persistentService.retailData.isNewAutoship">
                                  <mat-radio-button [value]="false" [checked]="false"> {{'choose_exit_autoship'|
                                  translate}} </mat-radio-button>
                                </mat-radio-group>
                              </div>
                              <div class="m-b-10">
                                <mat-radio-group name="opList" class="fx-col"
                                  [(ngModel)]="persistentService.retailData.isNewAutoship">
                                  <mat-radio-button [value]="true" [checked]="true"> {{'choose_new_autoship'| translate}}
                                  </mat-radio-button>
                                </mat-radio-group>
                              </div>
                            </div>
                          </div>
                          @if (!persistentService.retailData.isNewAutoship) {
                            <div
                              class="autoShipSelect m-t--15 fx-row xs-fx-main-center gt-xs-fx-main-end xs-fx-cross-center gt-xs-fx-cross-start xs-fx-flex-100-in-col print-fx-flex-20 gt-xs-fx-flex-20">
                              <mat-form-field class="autoship_drp fx-flex-100" appearance="outline">
                                <mat-select [(ngModel)]="selectedAutoship"
                                  (selectionChange)="changeSelectedAutosipId(selectedAutoship)">
                                  @for (autoship of AutoOrdersData; track autoship) {
                                    <mat-option [value]="autoship.AutoShipID">
                                      {{ "#Autoship - "+ autoship.AutoShipID + ' ('+ (autoship.SubTotal |
                                      currency:(autoship.CurrencySymbol || this.companyService.selectedCurrency.CurrencyCode):autoship.DecimalPoint)+' )'}}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <div class="borderBottom cart-items__header p-t-16 fx-row fx-flex-100-in-col">
                      <div class="fx-flex-50">
                        <span class="color2-f-s-14" translate="items_"></span>
                      </div>
                      <div class="fx-flex-30">
                        <span class="color2-f-s-14" translate="price"></span>
                      </div>
                      <div class="fx-flex-20">
                        <span class="color2-f-s-14" translate="global_quantity"></span>
                      </div>
                    </div>
                    @for (autoorderitem of itemsService.selectedAutoOrderItems; track autoorderitem) {
                      <div class="items fx-row fx-flex-100-in-col"
                        >
                        <div class="fx-row fx-flex-50">
                          <div class="cart-items__images fx-flex-15">
                            <img
                              [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/images/inventory'+autoorderitem.ImageUrl"
                              [default]="'assets/images/noimage.png'">
                            </div>
                            <div class="m-t-30 fx-col fx-flex-85">
                              <a class="product_detail_text itemName" [textContent]="autoorderitem.ProductName"
                              (click)="cart1Service.showProductDetail(autoorderitem, true, autoorderitem.HasOptions, false);"></a>
                              <!-- Warnings -->
                              @if (showBirthWarnings() || showCancerWarnings()) {
                                <sup class="c-color1" translate="prop_65">
                                </sup>
                              }
                              @if (showCancerWarnings() || showBirthWarnings()) {
                                <sup class="c-color1"
                                [innerHTML]="(showBirthWarnings() ? 'prop_65_es' : 'prop_65') | translate"></sup>
                              }
                            </div>
                          </div>
                          <div class="fx-row fx-main-start fx-cross-center fx-flex-30 xs-fx-flex-22">
                            <span [textContent]="autoorderitem.Price | currency: companyService.selectedCurrency.CurrencyCode"></span>
                          </div>
                          <div class="fx-row fx-main-start fx-cross-center fx-flex-20">
                            <div class="fx-row">
                              <div class="input-group fx-row fx-main-center fx-cross-center">
                                <span class="input-group-btn">
                                  <button mat-button-icon class="" type="button"
                                    (click)="cart1Service.decreaseQuantiy(autoorderitem, true, false)">
                                  <mat-icon class="c-gray">remove</mat-icon>
                                </button>
                              </span>
                              <input type="text" class="input-control" maxlength="2"
                                [(ngModel)]="getQuantityModel('autoship',autoorderitem)[autoorderitem.ItemID]" validate
                                inputonlynumber="true" (change)="checkQuantity('autoship',autoorderitem)"
                                (keyup)="($event.which === 38) ? cart1Service.increaseQuantiy(autoorderitem, true, false) : 0"
                                (keydown)="($event.which === 40) ? cart1Service.decreaseQuantiy(autoorderitem, true, false) : 0">
                              <span class="input-group-btn">
                                <button mat-button-icon class="" type="button"
                                  (click)="cart1Service.increaseQuantiy(autoorderitem, true, false)">
                                  <mat-icon class="c-gray">add</mat-icon>
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <div class="m-t-10 order-total-summary fx-col fx-flex-100-in-col">
                      <div class="fx-row fx-main-end fx-cross-stretch">
                        <label translate="sub_total"></label><strong
                      [textContent]="(orderService.calculateAutoOrderResponse.SubTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
                    </div>
                    <div class="fx-row fx-main-end fx-cross-stretch">
                      <label translate="discounttotal"></label><strong
                    [textContent]="(orderService.calculateAutoOrderResponse.DiscountTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
                  </div>
                  <div class="fx-row fx-main-end fx-cross-stretch">
                    <label translate="shippingtotal"></label><strong
                  [textContent]="(orderService.calculateAutoOrderResponse.ShippingTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
                </div>
                <div class="fx-row fx-main-end fx-cross-stretch">
                  <label translate="taxtotal"></label><strong
                [textContent]="(orderService.calculateAutoOrderResponse.TaxTotal | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
              </div>
            </div>
            <div class="m-t-10 order-items-total p-t-0 fx-flex-100-in-col">
              <div class="fx-row fx-main-end fx-cross-center">
                {{'global_total'|translate}} ( <span data-text="quantity"
              [textContent]="itemsService.selectedAutoOrderItems.length"></span> {{'item_'|translate}} ):
              <strong
              [textContent]="(orderService.calculateAutoOrderResponse.Total | currency: companyService.selectedCurrency.CurrencyCode)"></strong>
            </div>
          </div>
        </div>
      </mat-card-content>
    </div>
  </div>
</mat-card>
}
<mat-card appearance="outlined">
  <mat-card-content>
    <div class="fx-row">
      @if (configService.localSettings.Global.showRequiredTermsCheckbox) {
        <div class="m-t-10 m-b-10 m-r-15 text-right fx-flex-100"
          >
          <div class="fx-row fx-main-end fx-cross-stretch">
            <div class="mat-form-field ds-validate checkbox">
              <mat-checkbox class="ds-checkbox" color="primary" checkbox-validate="true" validate> <span
              [innerHTML]="('i_have_read_understand_and_agree' | translate)"></span></mat-checkbox>
            </div>
          </div>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
<br>
</div>
<div class="gt-xs-fx-flex-10"></div>
</div>
<div class="fx-row fx-main-center fx-cross-center fx-flex-100-in-col">
  <!-- Prop 65 warnings -->
  @if (showBirthWarnings() || showCancerWarnings()) {
    <div class="checkout__warnings">
      <div class="m-l-20"><span [innerHTML]="('whats_this_' | translate)"></span></div>
      <ol class="p-l-20">
        @if (showBirthWarnings()) {
          <li>
            <div translate="prop_65"></div>
            <div translate="warning_cause_birth"></div>
          </li>
        }
        @if (showCancerWarnings()) {
          <li>
            <div translate="prop_65"></div>
            <div translate="warning_cause_cancer"></div>
          </li>
        }
      </ol>
    </div>
  }
</div>
<div class="fx-row fx-flex-100-in-col">
  <div class="gt-xs-fx-flex-10"></div>
  <div class="fx-row xs-fx-col xs-fx-main-center gt-xs-fx-main-end xs-fx-cross-center gt-xs-fx-cross-stretch xs-fx-flex-100 gt-xs-fx-flex-80"
    >
    <div class="backButtom xs-fx-flex-100-in-col">
      <button mat-button (click)="backStep();" class="b-r-23" mat-raised-button color="basic">{{'back' | translate}}</button>
    </div>
    <div class="placeOrderButtom pl-15 xs-fx-flex-100-in-col">
      @if (isAutoshipChanged()) {
        <button id="place-order-btn" mat-raised-button color="primary" validate trigger-check="true"
        (success)="checkPlaceOrder()">{{'place_order_' | translate}}</button>
      }
    </div>
  </div>
  <div class="gt-xs-fx-flex-10"></div>

</div>
</div>
</div>
</div>